import { reactive } from "vue";
import { type Product } from "@src/api";

export type Serias = Record<string, Product>;
export type Good = {
  item: Product;
  quantity: number;
  result: number;
};
export type Goods = Record<string, Good[]>;

type State = {
  visible: boolean;

  selected: {
    serias: Serias;

    allGoodsIds: string[];
    goodsBySeria: Record<string, string[]>;
    seriaByGoodId: Record<string, string>;
    mapGoods: Record<string, Good>;
  };
};

const state = reactive<State>({
  visible: false,

  selected: {
    serias: {},

    allGoodsIds: [],
    goodsBySeria: {},
    mapGoods: {},
    seriaByGoodId: {},
  },
});

export const useOrders = () => {
  const setSelectedSerias = (serias: Serias) => {
    state.selected.serias = serias;
  };

  const setSelectedGoods = (goods: Goods) => {
    state.selected.mapGoods = {};
    state.selected.goodsBySeria = {};
    state.selected.seriaByGoodId = {};
    state.selected.allGoodsIds = [];

    Object.entries(goods).forEach(([seriaId, goodList]) => {
      const ids = [];

      goodList.forEach((good) => {
        ids.push(good.item.item_id);
        state.selected.mapGoods[good.item.item_id] = good;
        state.selected.seriaByGoodId[good.item.item_id] = seriaId;
      });

      state.selected.goodsBySeria[seriaId] = ids;
      state.selected.allGoodsIds.push(...ids);
    });
  };

  return {
    value: state,
    setSelectedSerias,
    setSelectedGoods,
  };
};
